import { useContext, useEffect } from 'react'
import { useWatch } from 'react-hook-form'

import { SelectOption } from 'components/Select'
import {
  AbTestsAddEditContext,
  AbTestsAddEditContextType,
} from 'features/ab-tests/contexts/AbTestsAddEditContext'
import { AbTestsCommonSchema } from '../abTestsCommonSchema'
import { DomainSlice } from './useGetDomainsForSelect'

type Props = {
  domains: SelectOption<DomainSlice>[]
}

export const useCanSaveAndStartAvailability = ({ domains }: Props) => {
  const { setCanSaveAndStart } = useContext<AbTestsAddEditContextType>(AbTestsAddEditContext)
  const { domainId } = useWatch<AbTestsCommonSchema>()

  useEffect(() => {
    if (
      domains.length === 0 ||
      domainId === undefined ||
      domainId === '' ||
      setCanSaveAndStart === undefined
    ) {
      return
    }

    const selectedDomain: SelectOption<DomainSlice> | undefined = domains.find(
      (domain: SelectOption<DomainSlice>) => domain.value === domainId,
    )
    if (selectedDomain === undefined) {
      throw Error('Domains should match.')
    }

    setCanSaveAndStart(selectedDomain.rawData?.activeAbTest === undefined)
  }, [domains, domainId])
}
